import { render } from "./ServiciosView.vue?vue&type=template&id=20210f87&scoped=true"
const script = {}

import "./ServiciosView.vue?vue&type=style&index=0&id=20210f87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20210f87"]])

export default __exports__